import { useEffect } from "react";
import BlogService from "../Service/BlogService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const CreateArticle = (title, content, date, images) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    function dataURItoBlob(dataURI) {
        // Séparer le type MIME et les données Base64
        const splitIndex = dataURI.indexOf(','); // Trouver la virgule qui sépare le type MIME des données
        const mimeType = dataURI.slice(5, splitIndex); // Extraire le type MIME
        const base64Data = dataURI.slice(splitIndex + 1); // Obtenir les données Base64
    
        // Convertir Base64 en tableau d'octets
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Uint8Array(byteCharacters.length);
    
        // Remplir le tableau d'octets
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
    
        // Retourner le Blob
        return new Blob([byteNumbers], { type: mimeType }); // Créer un Blob avec le type MIME
    }

    useEffect(() => {
        const createArticleWithImages = async () => {
            try {
                // Step 1: Upload each image and collect their IDs/URLs
                
                const imageIds = await Promise.all(
                    title.images.map(async (image) => {
                        const response = await BlogService.postImages(dataURItoBlob(image));
                        console.log(response);
                        
                        return "/api/imagess/"+response; // Adjust this if BlogService returns a different field for ID
                    })
                );

                // Step 2: Create the article with the image IDs attached
                await BlogService.postArticle(title.title, title.content, title.date, imageIds);

                navigate("/blog");
            } catch (error) {
                console.error("Erreur lors de la création de l'article :", error);
            }
        };

        createArticleWithImages();
    }, [title, content, date, images, dispatch, navigate]);

    return null; // This component does not render anything
};

export default CreateArticle;